export default "__VITE_ASSET__BXCzajE2__"